import { z } from "zod";
import { searchParam } from "@amber/ui";

export const searchPageSearchSchema = z.object({
  q: searchParam(z.string()),
  person: searchParam(z.string().regex(/^prf_[0-9A-Z]{26}$/)),
  language: searchParam(z.enum(["en", "de", "other"])),
  readiness: searchParam(z.enum(["eligible", "draft"])),
  corrected: searchParam(z.enum(["yes", "no"])),
});
export type SearchPageSearch = z.infer<typeof searchPageSearchSchema>;
